const StorybookUIRoot = () => {};

export default StorybookUIRoot;
